<template>
    <ListCommandesFournisseurs />
</template>

<script lang="ts">
    import ListCommandesFournisseurs from "@/components/GesCom/CommandeFournisseur/ListCommandesFournisseurs.vue";
    import { defineComponent } from "vue";

    export default defineComponent({
        name: "ListCommandesFournisseursPage",
        components: {
            ListCommandesFournisseurs,
        },
    });
</script>